(function () {
  const form = document.getElementById('NrThanksReviewForm');
  if (!form) return;

  const submitButton = form.querySelector('[data-nr-thanks-submit]');
  const successBanner = form.querySelector('[data-nr-thanks-success]');
  const errorBanner = form.querySelector('[data-nr-thanks-error]');
  const submitUrl = form.dataset.nrSubmitUrl || '/apps/nr-reviews/submit';
  const successMessage =
    form.dataset.nrSuccessMessage || 'Thank you — we got your review!';
  const errorMessage =
    form.dataset.nrErrorMessage || 'Something went wrong. Please try again.';

  function showBanner(banner, message) {
    if (!banner) return;
    banner.textContent = message;
    banner.hidden = false;
  }

  function hideBanners() {
    if (successBanner) successBanner.hidden = true;
    if (errorBanner) errorBanner.hidden = true;
  }

  form.addEventListener('submit', async function (event) {
    event.preventDefault();
    hideBanners();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const payload = {
      name: form.querySelector('[name="name"]')?.value.trim() || '',
      email: form.querySelector('[name="email"]')?.value.trim() || '',
      product: form.querySelector('[name="product"]')?.value.trim() || '',
      rating: form.querySelector('[data-nr-thanks-rating]:checked')?.value || '',
      message: form.querySelector('[name="message"]')?.value.trim() || '',
      website: form.querySelector('[name="website"]')?.value.trim() || '',
    };

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Submitting…';
    }

    try {
      const response = await fetch(submitUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json().catch(function () {
        return {};
      });

      if (!response.ok || !data.ok) {
        throw new Error(data.error || errorMessage);
      }

      showBanner(successBanner, successMessage);
      form.reset();
    } catch (error) {
      showBanner(errorBanner, error.message || errorMessage);
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = submitButton.dataset.defaultLabel || 'Submit';
      }
    }
  });

  if (submitButton && !submitButton.dataset.defaultLabel) {
    submitButton.dataset.defaultLabel = submitButton.textContent.trim();
  }
})();
